import React from "react";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@material-ui/core";
import { FileTypeData } from "../../types/documents";

const colors = {
  pdf: {
    enabled: "rgba(202,35,29,0.87)",
    disabled: "rgba(202,35,29,0.16)",
  },
  doc: {
    enabled: "rgba(43,87,154,0.87)",
    disabled: "rgba(43,87,154,0.24)",
  },
  xls: {
    enabled: "rgba(33,115,70,0.87)",
    disabled: "rgba(33,115,70,0.22)",
  },
  ppt: {
    enabled: "rgba(210,71,38,0.87)",
    disabled: "rgba(210,71,38,0.16)",
  },
  txt: {
    enabled: "rgba(100,100,100,0.87)",
    disabled: "rgba(100,100,100,0.22)",
  },
};

interface Props {
  state: FileTypeData;
  handleClick?: ((event: any) => void) | undefined;
  disabled?: boolean | undefined;
}

/** ファイル種類トグルボタン */
export function FileTypeToggleButton(props: Props) {
  const { state, handleClick, disabled } = props;
  const actualDisabled = disabled || false;

  //--------------------
  // コンポーネント
  return (
    <div style={{ display: "flex" }}>
      <IconButton
        name="pdf"
        aria-label="PDFファイル"
        style={{
          color: state.pdf ? colors.pdf.enabled : colors.pdf.disabled,
        }}
        onClick={handleClick}
        disabled={actualDisabled}
      >
        <FontAwesomeIcon icon={faFilePdf} />
      </IconButton>
      <IconButton
        name="doc"
        aria-label="ワードファイル"
        style={{
          color: state.doc ? colors.doc.enabled : colors.doc.disabled,
        }}
        onClick={handleClick}
        disabled={actualDisabled}
      >
        <FontAwesomeIcon icon={faFileWord} />
      </IconButton>
      <IconButton
        name="xls"
        aria-label="エクセルファイル"
        style={{
          color: state.xls ? colors.xls.enabled : colors.xls.disabled,
        }}
        onClick={handleClick}
        disabled={actualDisabled}
      >
        <FontAwesomeIcon icon={faFileExcel} />
      </IconButton>
      <IconButton
        name="ppt"
        aria-label="パワーポイントファイル"
        style={{
          color: state.ppt ? colors.ppt.enabled : colors.ppt.disabled,
        }}
        onClick={handleClick}
        disabled={actualDisabled}
      >
        <FontAwesomeIcon icon={faFilePowerpoint} />
      </IconButton>
      <IconButton
        name="txt"
        aria-label="テキスト"
        style={{
          color: state.txt ? colors.txt.enabled : colors.txt.disabled,
        }}
        onClick={handleClick}
        disabled={actualDisabled}
      >
        <FontAwesomeIcon icon={faFileAlt} />
      </IconButton>
    </div>
  );
}
